import React, { useEffect, useState } from "react";
import HelpPanel from "@cloudscape-design/components/help-panel";

import VariationsTable from "./components/vehicle-alarm";
// import { variationsData } from "./data/data";
import { AppLayout, Box, BreadcrumbGroup, ContentLayout, Header, Icon, Link, Spinner, SplitPanel } from "@cloudscape-design/components";
import { Navigation } from "../../../components/app/Navigation";
import { VehicleAlarms } from "./data/data";
import { generateClient } from "aws-amplify/api";
import { listVehicleAlarms } from "../../../graphql/queries";
import { ListVehicleAlarmsQueryVariables } from "../../../API";


// import '@cloudscape-design/global-styles/index.css'

export default function WAlarmVehicle() {
  const [activeHref, setActiveHref] = React.useState("/vehicles/alarms");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const [vehicleAlarmList, setVehicleAlarmList] = useState<VehicleAlarms[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  // console.log("test",vehicleAlarmList)

  useEffect(()=>{
    fetchOverview();
  }, []);

  async function fetchOverview(limit = 100) {
    try {
      const client = generateClient();
      let allVehiclesAlarms: VehicleAlarms[] = [];
      let nextToken: string | null = null;
  
      do {
        const variables: ListVehicleAlarmsQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listVehicleAlarms,
          authMode : 'userPool',
          variables,
        });
  
        const vehiclesAlarms = response.data.listVehicleAlarms.items;
        nextToken = response.data.listVehicleAlarms.nextToken ?? null;
  
        const newVehiclesAlarms: VehicleAlarms[] = vehiclesAlarms.map((vehicle: any) => {
          const formattedTimestamp = new Date(vehicle.timestamps).toLocaleString();
  
          return {
            id: vehicle.id,
            VehicleCode: vehicle.vehiclecode ?? "",
            Alarm: vehicle.alarm ?? "",
            Timestamps: formattedTimestamp,
          };
        });
  
        allVehiclesAlarms = [...allVehiclesAlarms, ...newVehiclesAlarms];
      } while (nextToken);
  
      setVehicleAlarmList(allVehiclesAlarms);
      setIsLoading(false);
    } catch (err) {
      console.log("error fetching vehicles: ", err);
    }
  }
  
  


  return ( <>
    <AppLayout
      breadcrumbs={
        <BreadcrumbGroup
        items={[
          {
            text: "Vehicles",
            href: "/vehicles", 
          },
          {
            text: "Alarms",
            href: "/vehicles/alarms", 
          },
         
        ]}
        />
      }
      navigation={
        <Navigation
          activeHref={activeHref}
          setActiveHref={setActiveHref} adminSubMenuOpen={false} setAdminSubMenuOpen={function (href: boolean): void {
            throw new Error('Function not implemented.');
          } }              // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
          // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
        />
      }
      //navigationOpen={true}
    //   navigation={
    //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
    //   }
      //notifications={
      //  <Flashbar
      //    items={[
      //      {
      //        type: "info",
      //        dismissible: true,
      //        content: "This is an info flash message.",
      //        id: "message_1",
      //      },
      //    ]}
      //  />
      //}
      toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
      onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
      tools={
        <HelpPanel
          footer={
            <div>
              <h3>
                Learn more <Icon name="external" />
              </h3>
              <ul>
                <li>
                  <a href="">Link to documentation</a>
                </li>
                <li>
                  <a href="">Link to documentation</a>
                </li>
              </ul>
            </div>
          }
          header={<h2>Help panel title (h2)</h2>}
        >
          <div>
            <p>
              This is a paragraph with some <b>bold text</b> and also some{" "}
              <i>italic text</i>.
            </p>
  
            <h3>h3 section header</h3>
            <ul>
              <li>Unordered list item.</li>
              <li>Unordered list item.</li>
            </ul>
  
            <h4>h4 section header</h4>
            <p>
              Code can be formatted as lines of code or blocks of code. Add
              inline code <code>like this</code> using a{" "}
              <code>{"<code>"}</code> tag.
              <pre>
                Or format blocks of code (like this) using a{" "}
                <code>{"<pre>"}</code> tag.
              </pre>
            </p>
  
            <h5>h5 section header</h5>
            <dl>
              <dt>This is a term</dt>
              <dd>This is its description.</dd>
              <dt>This is a term</dt>
              <dd>This is its description</dd>
            </dl>
          </div>
        </HelpPanel>
      }
      content={
        <ContentLayout
          header={
            <Header
              variant="h1"
              info={
                <Link
                  variant="info"
                  onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                >
                  Info
                </Link>
              }
             
            >
              {activeHref === "/vehicles/alarms"
                ? `Vehicles Alarms`
                : ""}
            </Header>
          }
        >
          
            <div className="contentPlaceholder" style={{marginTop : isLoading? "120px" : "0px"}}>
              {isLoading ? (
                 <Box textAlign="center" >
                 <Spinner size="large" />
                 <Box variant="p">Loading vehicle data...</Box>
               </Box>
              ): <VariationsTable VehicleMaster={vehicleAlarmList} />}
            
            </div>
         
        </ContentLayout>
      }
      splitPanel={
        <SplitPanel header="Split panel header">
          Split panel content
        </SplitPanel>
      }
    />
  </>
  );
}
function setVehicleList(newVehiclesAlarms: VehicleAlarms[]) {
  throw new Error("Function not implemented.");
}

